export default "__VITE_ASSET__B_Dlf72M__"